import { Collection } from 'modules/core/lib/mobx-rest'

import Form from 'modules/surveys/store/models/Form'

class Forms extends Collection<Form> {
  get cacheKey(): string {
    return 'surveysForms'
  }
  model() {
    return Form
  }
}

export default new Forms()
